import type { UserAddresses, pickupOptions } from './Address';
import type { FileInfo } from './File';

export type Order = {
  id: number
  user_id: number
  created_at: Date
  status: OrderStatus
  machine_type: MachineType
  number_parts: number
  material_id: number
  color: string
  type: keyof typeof ModellingType | ''
  delivery_time: Date
  modeling: boolean
  price: number
  pickup: typeof pickupOptions[number]
  address: UserAddresses['courierAddress'] | UserAddresses['courierOffice'] | UserAddresses['ourCourier'] | null
  files: FileInfo[]
  comment: string
};

export const orderStatus = {
  pending: 'pending',
  processing: 'processing',
  shipped: 'shipped',
  finished: 'finished',
  cancelled: 'cancelled',
} as const;

export const orderStatusList = [
  orderStatus.pending,
  orderStatus.processing,
  orderStatus.shipped,
  orderStatus.finished,
  orderStatus.cancelled,
] as const;

export type OrderStatus = keyof typeof orderStatus;

export type MachineType = 'milling' | '3d' | 'models';

export const ModellingType = { fullcontour: 'fullcontour', coping: 'coping' } as const;

export type NewOrder = Omit<Order, 'created_at' | 'user_id' | 'files'> & {
  file_ids: number[]
};
